import { DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker as XDatePicker } from "@mui/x-date-pickers/DatePicker";

const DatePicker = (props: DatePickerProps<any>) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <XDatePicker {...props} />
    </LocalizationProvider>
  );
};

export default DatePicker;
